// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD_uyJWPaGVhXOtARFVmn79s7mrINroFzA",
  authDomain: "vortex-af85f.firebaseapp.com",
  databaseURL: "https://vortex-af85f-default-rtdb.firebaseio.com",
  projectId: "vortex-af85f",
  storageBucket: "vortex-af85f.firebasestorage.app",
  messagingSenderId: "638854039132",
  appId: "1:638854039132:web:c0d450834f75a5d6630899",
  measurementId: "G-86VT11NSWV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
console.log("db",db)

export const auth = getAuth(app);
console.log("Auth",auth)

export async function loginAdmin() {
  await signInWithEmailAndPassword(auth, "vortex@gmail.com", "Allahloveu12@");
}